const message = {
  "button.home.sendFiles": "Enviar archivos",

  "button.options.record": "¡Graba ahora!",
  "button.options.upload": "Elige archivos",
  "button.options.gallery": "Ver álbum",
  "button.options.bingoGame": "Bingo",
  "button.options.photoChallengeGame": "Desafío de fotos",
  "button.options.quizGame": "Quiz",
  "button.options.teamMatchGame": "Team Match",
  "button.options.foodMenu": "Menú",
  "button.options.schedule": "Horario",
  "button.options.feed": "Feed de la Fiesta",
  "message.options.bingoGame": "¡Juega al bingo de la fiesta!",
  "message.options.photoChallengeGame": "¡Participa en el desafío de fotos!",
  "message.options.quizGame": "¡Pon a prueba tus conocimientos!",
  "message.options.teamMatchGame": "¿De qué equipo eres parte?",
  "message.options.foodMenu": "¡Consulta el menú de la fiesta!",
  "message.options.schedule": "¡Consulta el horario del evento!",
  "message.options.record": "¡Graba tu mensaje especial ahora!",
  "message.options.upload":
    "¡Comparte las mejores fotos y videos de la fiesta!",
  "message.options.gallery": "¡Mira las fotos del evento!",
  "message.options.feed": "¡Sigue la línea de tiempo del evento!",

  "title.terms": "Términos de uso",
  "title.notFound": "Vaya, parece que esta página no existe.",
  "title.eventNotFound": "Error al acceder al evento",

  "subtitle.goBackTo": "Volver a",
  "subtitle.eventNotFound": "Evento no encontrado o expirado.",

  "message.termsOfUse":
    "Al utilizar nuestro sistema, usted acepta nuestros <code>Términos de uso</code>",
  "message.termFirstParagraph":
    "Al utilizar nuestro sistema de carga de fotos y videos, usted, como invitado al evento, acepta que recopilemos y carguemos sus datos, incluidas fotos, videos e información personal, y los pongamos a disposición del anfitrión del evento.",
  "message.termSecondParagraph":
    "No accedemos a sus archivos a menos que el cliente lo solicite para brindar soporte técnico, limitado a lo necesario.",
  "message.termThirdParagraph":
    "La empresa no comparte datos con terceros y mantiene la confidencialidad de la información, excepto cuando lo exija la ley.",
  "message.termsFirstParagraph":
    "Al utilizar nuestro sistema de carga de fotos y videos, usted, como invitado al evento, acepta que recopilemos y carguemos sus datos, incluidas fotos, videos e información personal, y los pongamos a disposición del anfitrión del evento.",
  "message.termsSecondParagraph":
    "No accedemos a sus archivos a menos que el cliente lo solicite para brindar soporte técnico, limitado a lo necesario.",
  "message.termsThirdParagraph":
    "La empresa no comparte datos con terceros y mantiene la confidencialidad de la información, excepto cuando lo exija la ley.",
  "message.shareLink": "¡Comparte tus momentos favoritos de la fiesta!",

  // recorder
  "button.recorder.home": "Volver a la pantalla inicial",
  "button.recorder.understood": "¡Entendido!",
  "button.recorder.close": "Cerrar",
  "button.recorder.share": "Compartir",
  "button.recorder.back": "Regresar",

  "title.recorder.permissionsToRecordAudioVideo": "Permiso para grabar",
  "title.recorder.success": "¡Éxito!",
  "title.recorder.uploading": "Enviando",
  "title.recorder.alert": "¡Alerta!",
  "title.recorder.saving": "Guardando",
  "title.recorder.waiting": "Esperando",
  "title.recorder.share": "¡Comparte!",
  "title.recorder.error": "¡Error!",
  "title.recorder.permissionCameraOrMicrophoneDenied": "Permiso no concedido",
  "title.recorder.terms": "Términos de uso",

  "subtitle.recorder.nextScreenClickAllow":
    "En la siguiente pantalla haz clic en <code>Permitir</code>.",
  "subtitle.recorder.allowReinforcement":
    "Es necesario que hagas clic en <code>Permitir</code> para grabar tu mensaje.",
  "subtitle.recorder.share": "¡Invita a tus amigos a grabar también!",
  "subtitle.recorder.dontRefreshPage":
    "Por favor, no actualices ni cierres esta página.",
  "subtitle.recorder.status.success": "¡Tu mensaje ha sido grabado con éxito!",
  "subtitle.recorder.browserNotSupported":
    "Tu navegador no es compatible o no se concedió el permiso.",
  "subtitle.recorder.tryGrantPermission":
    "1. Actualiza la página y permite el uso de la cámara.",
  "subtitle.recorder.tryAnotherBrowser":
    "2. Intenta usar otro navegador como {chrome} o {safari}.",
  "subtitle.recorder.mustLongerThan":
    "El mensaje debe durar más de <code>5 segundos</code>.",
  "subtitle.recorder.offline":
    "Estás desconectado. Por favor, verifica tu conexión.",
  "subtitle.recorder.startRecord": "Haz clic para comenzar a grabar.",
  "subtitle.recorder.recording": "Grabando...",
  "subtitle.recorder.uploadError": "Error al subir el video.",
  "subtitle.recorder.tryAgain": "Verifica tu conexión e inténtalo de nuevo.",
  "subtitle.recorder.permissionCameraOrMicrophoneDenied":
    "No se concedió el permiso de cámara/micrófono.",
  "subtitle.recorder.trySafariBrowser":
    "1. Usa el navegador <code>SAFARI</code>",
  "subtitle.recorder.changeSiteSettingsUsingSafari":
    '2. Haz clic en el botón <code>"aA"</code> en la barra de URL y en <code>"Configuración del sitio"</code>',
  "subtitle.recorder.grantCameraAndMicrophonePermissions":
    "3. <code>Permite el uso</code> de la cámara y el micrófono",
  "subtitle.recorder.refreshPage": "4. Actualiza la página",
  "subtitle.recorder.tryChromeBrowser":
    "1. Usa el navegador <code>CHROME</code>",
  "subtitle.recorder.changeSiteSettingsUsingChrome":
    '2. Accede a la configuración del sitio y haz clic en <code>"Permisos"</code>',

  "message.recorder.almostDone": "¡Casi terminado! Solo unos segundos más.",
  "message.recorder.sendingMessage":
    "Ahora estamos enviando tu mensaje. Puede tardar un poco porque está lleno de cosas geniales.",

  "title.recorder.upload": "Subida",

  "subtitle.recorder.filesReadyToUpload": "Archivo listo para subir:",

  "subtitle.recorder.fileWithError": "Archivo que no se subirá:",

  "message.recorder.fileSizeError": "El archivo supera el tamaño permitido",

  "button.recorder.send": "Enviar",

  "message.recorder.uploading":
    "Por favor, no actualices ni cierres esta página.",

  "message.recorder.uploadError": "Error al subir el archivo.",

  "title.recorder.uploadFailure": "Fallo en la subida",

  "title.recorder.completed": "Completado",

  "message.recorder.uploadComplete": "Subida completada",

  "message.recorder.fileUploaded": "Archivo subido con éxito",

  "message.recorder.uploadFailed": "Error al subir el archivo",

  "message.recorder.checkYourConnectionAndTryAgain":
    "Por favor, comprueba tu conexión e inténtalo de nuevo",

  "button.recorder.ok": "¡OK!",

  "title.recorder.shareMoments": "Envía tu mensaje",

  "subtitle.recorder.forThe1YearAnniversary": "Para el 1er Aniversario",

  "subtitle.recorder.now": "Para Ahora",

  "message.recorder.uploadMaxFilesLimit": "Sube <code>1 vídeo</code> por vez.",

  "message.recorder.uploadLimit": "Límite máximo:",

  "message.recorder.videoSizeLimit": "<code>800MB</code> por vídeo.",

  "button.recorder.send_video": "Enviar vídeo",

  "message.recorder.uploadTip":
    "Haz clic en el botón de arriba y selecciona el vídeo que acabas de grabar.",

  "title.recorder.guide.instructionsToRecord": "Instrucciones para grabar",

  "subtitle.recorder.guide.instructions":
    "Abre la <code>cámara</code> de tu dispositivo en modo selfie y graba tu mensaje de hasta <code>2 minutos</code>.",

  "subtitle.recorder.guide.moreInstructions":
    "Luego, vuelve aquí para enviar tu mensaje.",

  "message.recorder.instructions":
    "<code>Abre la aplicación de cámara</code> de tu dispositivo en modo selfie y graba tu mensaje de hasta <code>2 minutos</code>.",
  "button.recorder.sendVideo": "Enviar video",
  "message.recorder.uploadTip.ios":
    "💡 Para mejor calidad, selecciona un video desde tu galería",

  // uploader
  "button.uploader.send_photos": "Enviar fotos",
  "button.uploader.send_video": "Enviar video",
  "button.uploader.close": "Cerrar",
  "button.uploader.share": "Compartir",
  "button.uploader.back": "Regresar",
  "button.uploader.send": "Enviar",
  "button.uploader.continue": "Continuar",
  "button.uploader.ok": "OK!",

  "title.uploader.success": "¡Éxito!",
  "title.uploader.uploading": "Enviando",
  "title.uploader.alert": "¡Alerta!",
  "title.uploader.saving": "Guardando",
  "title.uploader.waiting": "Esperando",
  "title.uploader.share": "¡Comparte!",
  "title.uploader.error": "¡Error!",
  "title.uploader.upload": "Subir",
  "title.uploader.shareMoments": "Comparte momentos",
  "title.uploader.uploadFailure": "Error al subir",
  "title.uploader.completed": "Completado",
  "title.uploader.terms": "Términos de uso",

  "subtitle.uploader.filesWithError":
    "Archivos que <code>no se enviarán</code>:",
  "subtitle.uploader.uploadHistory": "Cargas completadas",
  "subtitle.uploader.filesReadyToUpload": "Archivos listos para subir:",

  "message.uploader.uploadMaxFilesLimit":
    "Envía hasta <code>50 fotos o 1 video</code> a la vez.",
  "message.uploader.uploadLimit": "Límite máximo:",
  "message.uploader.photoSizeLimit": "<code>20MB</code> por foto",
  "message.uploader.videoSizeLimit": "<code>500MB</code> por video",
  "message.uploader.fileSizeError": "Archivo excede tamaño permitido",
  "message.uploader.uploading":
    "Por favor, no actualices ni cierres esta página.",
  "message.uploader.uploadError": "Error al subir.",
  "message.uploader.maxFilesLimitError":
    "Selecciona un máximo de <code>50 fotos</code>.",
  "message.uploader.notFoundFilesToUpload":
    "<code>No hay archivos para subir.</code>.",
  "message.uploader.checkFileSizeAndTryAgain":
    "Por favor, verifica el <code>tamaño del archivo</code> e inténtalo de nuevo.",
  "message.uploader.uploadComplete": "Carga completada",
  "message.uploader.allFilesUploaded": "Todos los archivos se han subido",
  "message.uploader.nFilesUploaded": "{n} archivo(s) subido(s)",
  "message.uploader.nFilesNotUploaded": "{n} archivo(s) no subido(s)",
  "message.uploader.noFilesUploaded": "No se han subido archivos",
  "message.uploader.checkYourConnectionAndTryAgain":
    "Verifica tu conexión e inténtalo de nuevo.",
  "message.uploader.uploadVerySlow":
    "Si la carga es lenta, selecciona unas pocas fotos a la vez",
  "message.uploader.uploadTip":
    "Para mantener la calidad del archivo, sube archivos de la galería de tu dispositivo.",

  "title.guestForm": "Tu Perfil",
  "placeholder.guestForm.name": "Tu nombre o apodo",
  "message.guestForm.nameRequired": "El nombre es obligatorio",
  "message.guestForm.dataInfo":
    "Los datos proporcionados no son obligatorios. Serán mostrados solo como una firma en las fotos y videos que envíes.",
  "button.guestForm.takePhoto": "Tómate una selfie (opcional)",
  "button.guestForm.submit": "Guardar",
  "button.guestForm.uploading": "Guardando...",
  "button.guestForm.skip": "Continuar de forma anónima",
  "message.cameraNotAvailable":
    "No se puede acceder a la cámara. Asegúrate de haber otorgado permisos para la cámara.",
  "title.guestForm.cropPhoto": "Recortar foto",
  "button.guestForm.selectPhoto": "Seleccionar foto (opcional)",

  "title.photoChallenge": "Desafío de Fotos",
  "subtitle.photoChallenge.tasks": "Tareas",
  "subtitle.photoChallenge.done": "Completadas",
  "message.photoChallenge.intro":
    "El objetivo es tomar fotos según lo indicado en cada objetivo.",
  "message.photoChallenge.todo": "Completa un desafío",
  "message.photoChallenge.done": "Desafíos completados",
  "button.photoChallenge.start": "Iniciar",

  "title.quiz": "Cuestionario",
  "subtitle.quiz.intro": "¿Aceptas el desafío?",
  "subtitle.quiz.result": "Resultado",
  "message.quiz.intro":
    "¡Entre todos los invitados, demuestra que eres la persona que más conoce a la pareja!",
  "button.quiz.start": "Comenzar",
  "button.quiz.confirm": "Confirmar",
  "message.quiz.result":
    "Acertaste {score} de {totalQuestions} preguntas en {time} segundos",
  "message.quiz.saving": "Guardando...",
  "button.quiz.share": "Compartir Resultado",
  "message.quiz.congrats": "🎉 ¡Felicidades! 🎉",

  "message.bingo.intro":
    "¿Puedes completar el bingo mientras te diviertes con cada desafío?",
  "button.bingo.start": "Iniciar",
  "label.bingo.fullCard": "Cartón Completo",
  "label.bingo.line": "Línea",
  "label.bingo.firstColumn": "1ª - Columna",
  "label.bingo.firstRow": "1ª - Línea",
  "subtitle.bingo.results": "Resultados",
  "message.bingo.selectChallenge": "Haz clic para ver y completar el desafío",
  "button.bingo.removeChallenge": "Eliminar desafío",
  "button.bingo.continue": "Continuar",
  "message.bingo.progress": "¡Sigue completando los desafíos del bingo!",
  "button.bingo.share": "Compartir",

  "message.photoChallenge.intro.new":
    "Es fácil: ¡sigue las instrucciones y diviértete tomando fotos!",
  "message.photoChallenge.inProgress.new":
    "Selecciona un desafío a continuación y envía tu foto.",
  "button.photoChallenge.share": "Compartir Resultado",
  "message.photoChallenge.completed":
    "¡Completaste todos los {total} desafíos de foto!",
  "message.photoChallenge.congrats": "🎉 ¡Felicidades! 🎉",

  "title.teamMatch": "Team Match",
  "subtitle.teamMatch.intro": "Descubre tu equipo",
  "subtitle.teamMatch.result": "Resultado",
  "message.teamMatch.intro":
    "¡Haz la prueba y descubre si eres parte del equipo {teamA} o del equipo {teamB}!",
  "button.teamMatch.start": "Iniciar",
  "button.teamMatch.next": "Siguiente",
  "message.teamMatch.result": "¡Tu equipo es <code>{team}</code>!",
  "message.teamMatch.saving": "Guardando...",
  "button.teamMatch.share": "Compartir Resultado",

  "feed.loading": "Cargando feed...",
  "feed.empty": "No hay elementos en el feed todavía.",
  "feed.imageAlt": "Imagen Subida",
  "feed.anonymousGuest": "Invitado anónimo",
  "feed.imageUploader.title": "Foto Subida",

  "feed.quiz.title": "Cuestionario",
  "feed.quiz.description":
    "{guestName} completó el cuestionario. Resultado: {score}/{total} en {time} segundos",
  "feed.photoChallenge.title": "Desafío de Fotos",
  "feed.photoChallenge.description":
    "{guestName} completó el desafío: {challenge}",
  "feed.teamMatch.title": "Team Match",
  "feed.teamMatch.description":
    "{guestName} participó en Team Match. Resultado: {teamAName} {scoreA} x {scoreB} {teamBName}",
  "feed.newGuest.title": "Nuevo Invitado",
  "feed.newGuest.description": "{guestName} se unió al evento",
  "feed.videoRecorder.title": "Nuevo Mensaje",
  "feed.videoRecorder.description": "{guestName} envió un nuevo mensaje",
  "feed.default.title": "Actividad",
  "feed.default.description": "Ocurrió una nueva actividad",

  "feed.ctaPost.ctaButton":
    "¿Te está gustando el evento? ¡Publica una foto tú también!",
  "feed.imageUploader.description":
    "{guestName} envió archivos a la galería de la fiesta",
  "feed.cdt-imageUploader.title": "Nuevo Mensaje",
  "feed.cdt-imageUploader.description":
    "{guestName} envió archivos para las Bodas de 1 Año!",
  "feed.quiz.ctaButton": "Pon a prueba tus conocimientos",
  "feed.photoChallenge.ctaButton": "Haz también un desafío",
  "feed.teamMatch.ctaButton": "Participa en el Team Match",
  "feed.videoRecorder.ctaButton": "Graba un mensaje ahora",
  "feed.videoUploader.title": "Nuevo Mensaje",
  "feed.videoUploader.description":
    "{guestName} envió un vídeo a la galería de la fiesta",
  "feed.cdt-videoUploader.title": "Nuevo Mensaje",
  "feed.cdt-videoUploader.description":
    "{guestName} envió un vídeo para las Bodas de 1 Año!",
  "feed.newPost.title": "Nueva Publicación",
  "feed.cdtVideoRecorder.description":
    "<code>{guestName}</code> ya dejó su mensaje para las <code>bodas de 1 año!</code>",
  "feed.cdtVideoRecorder.ctaButton": "¡Haz lo mismo!",
  "feed.placeholder.newPost": "Crear publicación...",
  "feed.placeholder.newPostMessage": "Escribe tu mensaje...",

  "feed.menu.title.interaction": "Enviar archivos",
  "feed.menu.button.options.newPost": "Crear publicación",
  "feed.menu.message.options.newPost": "¡Crea una publicación ahora mismo!",
  "feed.menu.button.options.record": "Grabar ahora",
  "feed.menu.message.options.record": "¡Graba ahora tu mensaje especial!",
  "feed.menu.button.options.upload": "Elegir archivos",
  "feed.menu.message.options.upload":
    "¡Comparte las mejores fotos y vídeos de la fiesta!",
  "feed.menu.title.gallery": "Galería de la fiesta",
  "feed.menu.button.options.gallery": "Ver álbum",
  "feed.menu.message.options.gallery": "¡Mira las fotos del evento!",
  "feed.menu.title.games": "Juegos",
  "feed.menu.button.options.bingoGame": "Bingo",
  "feed.menu.message.options.bingoGame": "¡Juega al bingo de la fiesta!",
  "feed.menu.button.options.photoChallengeGame": "Desafío de fotos",
  "feed.menu.message.options.photoChallengeGame":
    "¡Participa en el desafío de fotos!",
  "feed.menu.button.options.quizGame": "Quiz",
  "feed.menu.message.options.quizGame": "¡Pon a prueba tus conocimientos!",
  "feed.menu.button.options.teamMatchGame": "Team Match",
  "feed.menu.message.options.teamMatchGame": "¿De qué equipo eres?",
  "feed.menu.title.info": "Sobre el evento",
  "feed.menu.button.options.foodMenu": "Menú",
  "feed.menu.message.options.foodMenu": "¡Mira el menú de la fiesta!",
  "feed.menu.button.options.schedule": "Programación",
  "feed.menu.message.options.schedule":
    "¡Consulta la programación de la fiesta!",
  "feed.menu.title.guestInfo": "Tu información",
  "feed.menu.options.anonymousGuest": "Invitado anónimo",
  "feed.menu.options.guestEditInfo": "¡Haz clic para editar tu información!",
  "feed.menu.title.other": "Otros",
  "feed.menu.button.options.language": "Idioma",
  "feed.menu.message.options.languageInfo": "¡Haz clic para cambiar el idioma!",
  "feed.button.options.cancel": "Cancelar",
  "feed.button.options.confirm": "Confirmar",
  "feed.menu.button.options.share": "Compartir",
  "feed.menu.message.options.shareInfo": "¡Comparte el enlace del evento!",
  "feed.menu.button.options.about": "Sobre la Cápsula del Tiempo",
  "feed.menu.message.options.about": "¡Conoce la Cápsula del Tiempo!",
  "feed.createPost.title": "Nueva Publicación",
  "feed.button.creatingPost": "Creando...",
  "feed.button.createPost": "Publicar",
  "feed.editImage.title": "Editar Imagen",
  "feed.newPost.selectImage": "Seleccionar imagen",

  "feed.createPost.info.sendingPostImage": "Enviando imagen...",
  "feed.createPost.info.creatingPost": "Creando publicación...",
  "feed.createPost.info.finalizingPost": "Finalizando...",
  "feed.menu.button.options.games": "Juegos",
  "feed.modalGames.title": "Juegos de la Fiesta",
  "feed.bingo.result.line": "Línea",
  "feed.bingo.result.column": "Columna",
  "feed.bingo.result.fullCard": "Cartón completo",
  "feed.bingo.title": "Bingo",
  "feed.bingo.description": "{guestName} completó {challenge} del bingo",
  "feed.bingo.ctaButton": "¡Juega al bingo también!",
  "feed.deletePost.title": "Eliminar publicación",
  "feed.deletePost.message":
    "¿Estás seguro de que deseas eliminar esta publicación? Esta acción no se puede deshacer.",

  "title.uploader.modalMixedEventTitle":
    "¿CUÁNDO quieres que los novios reciban tu foto o vídeo?",
  "button.options.sendNow": "Enviar Ahora",
  "message.options.sendNow":
    "¡Los novios tendrán acceso a los archivos de inmediato!",
  "button.options.sendLater": "En su Primer Aniversario",
  "message.options.sendLater": "¡Envíalo a la Cápsula del Tiempo del evento!",

  "button.cancel": "Cancelar",
  "button.delete": "Eliminar",
  "button.quiz.continue": "Continuar",
  "button.recorder.recorder.back": "Regresar",
  "button.teamMatch.continue": "Continuar",
  "cropper.remove.frame": "Quitar Marco",
  "cropper.use.frame": "Usar Marco",
  "error.guestForm.fileTooLarge": "El archivo debe tener como máximo 10MB",
  "error.guestForm.invalidFileType":
    "Por favor, seleccione un archivo de imagen válido",
  "error.guestForm.removePhotoFailed":
    "Error al eliminar foto. Inténtalo de nuevo.",
  "error.guestForm.saveFailed": "Error al guardar. Inténtalo de nuevo.",
  "error.guestForm.updateFailed": "Error al guardar. Inténtalo de nuevo.",
  "error.guestForm.uploadFailed": "Error al subir la foto. Inténtalo de nuevo.",
  "title.guestForm.unsavedChanges": "Cambios no guardados",
  "message.guestForm.unsavedChanges":
    "Tienes cambios no guardados. ¿Deseas salir sin guardar?",
  "button.guestForm.cancel": "Cancelar",
  "button.guestForm.exitWithoutSaving": "Salir sin guardar",
  "message.bingo.remove.warning":
    "Al eliminar este desafío, tus resultados serán recalculados.",
  "message.bingo.remove.warning.detail1":
    "Las filas y columnas afectadas por la eliminación serán revisadas.",
  "message.bingo.remove.warning.detail2":
    "Si hay otros logros completados, la hora se actualizará al momento actual.",
  "message.guest.nameRequired": "El nombre es obligatorio",
  "message.quiz.progress":
    "¡El cuestionario aún está en curso! ¡Continúa y demuestra lo que vales!",
  "message.teamMatch.progress":
    "¡El juego aún está en curso! ¡Continúa y descubre tu equipo!",
  "title.feed": "Feed de la Fiesta",
};

export default message;
